import theme from '~/theme'

import { TSizingMapColors } from './types'

export const sizingMessagesColorsMap: TSizingMapColors = {
  FIT: theme.colors.status.success,
  SOME_LOOSE: theme.colors.status.warning,
  SOME_TIGHT: theme.colors.status.warning,
}
